export default{
  $newFashion:true,
}
